import React from 'react';

export const EventbriteWordmark: React.FC = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="139"
      height="25"
      viewBox="0 0 139 25"
      fill="none"
    >
      <path
        d="M116.151 2.70097C116.155 4.06671 115.052 5.17714 113.687 5.18119C112.322 5.18525 111.212 4.08139 111.208 2.71565C111.204 1.34992 112.307 0.23949 113.672 0.235436C115.037 0.231382 116.147 1.33524 116.151 2.70097Z"
        fill="#161719"
      />
      <path
        d="M105.802 8.15179C106.231 6.80185 107.502 5.57631 109.094 5.57631C109.823 5.57631 110.473 5.79239 110.768 6.03575V10.1652C110.174 9.81602 109.255 9.65123 108.42 9.65123C106.802 9.65123 105.802 10.5265 105.802 12.5508V18.0517H101.43V6.01724H105.802L105.802 8.15179Z"
        fill="#161719"
      />
      <path
        d="M72.4731 5.692C70.9129 5.692 69.3036 6.3598 68.5864 7.82222V6.01721H64.2145V18.0521H68.5864V12.1416C68.5864 10.3322 69.1805 9.14706 70.6655 9.14706C71.9879 9.14706 72.448 10.0114 72.448 11.6571V18.0521H76.8199V10.497C76.8199 7.78697 75.3425 5.692 72.4731 5.692Z"
        fill="#161719"
      />
      <path
        d="M47.5784 6.01719L44.9607 13.4915H44.8506L42.2329 6.01719H37.6462L42.1261 18.0521H47.3331L51.8129 6.01719H47.5784Z"
        fill="#161719"
      />
      <path d="M115.868 6.01719H111.496V18.0521H115.868V6.01719Z" fill="#161719" />
      <path
        d="M122.542 9.02586H125.673V6.01724H122.542V2.69529H119.921C119.921 4.50824 118.532 6.01724 116.598 6.01724V9.02586H118.216V14.7029C118.216 17.5381 120.13 18.3729 122.157 18.3729C123.804 18.3729 124.854 17.967 125.773 17.2936V14.4595C125.046 14.7542 124.453 14.8644 123.914 14.8655C123.027 14.8644 122.542 14.4583 122.542 13.4358V9.02586Z"
        fill="#161719"
      />
      <path
        d="M86.2419 9.02586H83.1107V13.4358C83.1107 14.4583 83.5958 14.8644 84.4833 14.8655C85.0219 14.8644 85.615 14.7542 86.3422 14.4595V17.2936C85.4231 17.967 84.3732 18.3729 82.7258 18.3729C80.699 18.3729 78.7846 17.5381 78.7846 14.7029V9.02586H77.1666V6.01724C79.1011 6.01724 80.4897 4.50823 80.4897 2.69529H83.1107V6.01724H86.2419V9.02586Z"
        fill="#161719"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.8443 12.2267C25.8443 16.0321 28.5939 18.3795 32.4501 18.3795C35.9531 18.3795 38.0474 16.5483 38.5435 13.7644H34.9577C34.5532 14.7094 33.7987 15.1143 32.6114 15.1143C31.2901 15.1143 30.2118 14.4126 30.1039 12.9284H38.5435V11.7138C38.5435 8.44865 36.4131 5.6953 32.3967 5.6953C28.7188 5.6953 25.8443 8.53704 25.8443 12.2267ZM30.1573 10.8233C30.3187 9.68946 30.939 8.82624 32.3411 8.82624C33.6352 8.82624 34.3362 9.74402 34.3896 10.8233H30.1573Z"
        fill="#161719"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M50.7477 12.2267C50.7477 8.53704 53.6223 5.6953 57.3001 5.6953C61.3166 5.6953 63.447 8.44865 63.447 11.7138V12.9284H55.0073C55.1153 14.4126 56.1935 15.1143 57.5149 15.1143C58.7022 15.1143 59.4567 14.7094 59.8611 13.7644H63.447C62.9509 16.5483 60.8565 18.3795 57.3536 18.3795C53.4974 18.3795 50.7477 16.0321 50.7477 12.2267ZM57.2445 8.82624C55.8425 8.82624 55.2221 9.68946 55.0608 10.8233H59.2931C59.2397 9.74402 58.5387 8.82624 57.2445 8.82624Z"
        fill="#161719"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M138.999 11.7138C138.999 8.44865 136.869 5.6953 132.852 5.6953C129.105 5.6953 126.301 8.42137 126.301 12.2267C126.301 16.0321 129.05 18.3795 132.907 18.3795C136.41 18.3795 138.504 16.5483 139 13.7644H135.414C135.01 14.7094 134.255 15.1143 133.068 15.1143C131.747 15.1143 130.668 14.4126 130.56 12.9284H139V11.7138H138.999ZM130.614 10.8233C130.775 9.68946 131.396 8.82624 132.798 8.82624C134.092 8.82624 134.793 9.74402 134.846 10.8233H130.614Z"
        fill="#161719"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M91.4466 8.07763C92.0408 6.64584 93.3894 5.67458 95.414 5.67458C98.9486 5.67458 100.757 8.4574 100.757 12.0227C100.757 15.588 98.9486 18.3708 95.3323 18.3708C93.3894 18.3708 91.8784 17.4257 91.2035 15.9666L90.448 18.0517H87.0747V1.02782H91.4466V8.07763ZM91.4466 12.1023C91.4466 13.8583 92.3919 14.9932 93.8757 14.9932C95.5754 14.9932 96.3582 13.7491 96.3582 12.0205C96.3582 10.2919 95.5754 9.07617 93.8757 9.07617C92.3908 9.07617 91.4466 10.2111 91.4466 11.9397V12.1023Z"
        fill="#161719"
      />
      <path
        d="M19.827 19.6136C19.827 18.2185 19.1857 16.974 18.1822 16.1573L10.2164 9.94629C10.0845 9.84531 10.2191 9.64069 10.3653 9.72219L13.4761 11.4645C14.8862 12.2546 16.6684 11.7975 17.5231 10.4255C18.4231 8.97814 17.9474 7.07197 16.4691 6.21898L11.9029 3.58027C11.7586 3.49613 11.8649 3.27645 12.0216 3.33757L14.1191 4.17728C14.1245 4.17905 14.1732 4.19677 14.1927 4.20385C14.4159 4.2818 14.6541 4.32432 14.9039 4.32432C16.0421 4.32432 16.9757 3.42438 17.0563 2.35437C17.1609 0.96903 16.1006 0 14.8357 0H5.13922C3.89472 0 2.84863 1.01775 2.86546 2.25959C2.87343 2.91949 3.16928 3.50853 3.63253 3.91244C3.98153 4.21625 5.15694 5.15694 5.71586 5.60337C5.81595 5.68309 5.75926 5.84252 5.63171 5.84252H3.69099C1.65018 5.85492 0 7.51308 0 9.55566C0 10.5885 0.421625 11.523 1.10278 12.1953L12.3379 22.8732C13.1333 23.6146 14.1997 24.069 15.3734 24.069C17.834 24.069 19.827 22.0733 19.827 19.6136Z"
        fill="#161719"
      />
    </svg>
  );
};
